import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, ToastController, NavParams, AlertController, App, ViewController } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { DataProvider } from '../../providers/data/data';
import { HttpClient} from '@angular/common/http';
import { first } from 'rxjs/operators';

import { DashboardPage } from '../dashboard/dashboard';

@IonicPage()
@Component({
  selector: 'page-task',
  templateUrl: 'task.html',
})
export class TaskPage {
  private tasks1 = [];
  private taskInput = [];
  private a: any;
  private TimeCard = [];
  private spendTime: any;
  private userId: any;
  private id: any;
  private userTaskId = [];
  private retime: any;
  private date: any;
  private companyId: any;
  private value: any;
  private type: any;
  private workTime: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    public httpClient: HttpClient,
    public app: App,
    private viewCtrl: ViewController,
    ) {
      if(this.navParams.get('type')) {
        this.type = this.navParams.get('type');
        this.workTime = this.navParams.get('workTime');
      }
      if(this.type == undefined) {
        this.type = null;
      }
  }

  ionViewDidLoad() {
    this.taskInput = [];
    this.data.currentTabName = 'Зарцуулсан цаг';
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.userId = this.navParams.get('userId');
    if(this.navParams.get('data')) {
      this.retime = this.navParams.get('data');
      this.data.workTime = this.retime.time;      
      this.workTime = this.data.workTime;
    }
    if(!this.navParams.get('type')) {      
      if(this.data.workTime == undefined) {
        if(this.navParams.get('data')) {
          this.rest.addTimeTable('214', '0', this.data.userId).subscribe(res =>{
            });
          let nav = this.app.getRootNavs();
          nav[0].setRoot(DashboardPage);
        } else {
          this.getTask();
        }
      } else {
        this.getTask();
      }
    } else {
      this.getTask();
    }
  }
  getTask(){
    this.rest.GetUserTasks(this.data.userId).subscribe(res => {
      this.tasks1 = res;
      for(let i = 0; i  < this.tasks1.length;i++) {
        if(this.tasks1[i].today_spend_time != 0) {
          this.taskInput[i] = this.tasks1[i].today_spend_time;
        }
      }
    });
  }
  async addZTime(){
    this.userTaskId = [];
    let sum = 0;
    for(let i = 0; i  < this.taskInput.length;i++) {
      if(this.taskInput[i] != null) {
        sum = sum + parseFloat(this.taskInput[i]);
        this.userTaskId.push({id: this.tasks1[i].id, value: this.taskInput[i]});
      }
    }
    // this.getTask();
    if(sum < 0){
      this.showToast1('Таскны цаганд хасах тоо оруулж болохгүй. Шалгаад зөв бөглөнө үү!!!');
    } else if(sum > 0){
      if(parseFloat(this.data.workTime) < sum) {
        this.showToast1('Таны таскны цаг ажилсан цагнаас их байна. Зөв бөглөнө үү!!!');
      } else if(parseFloat(this.data.workTime) > sum){
        this.showToast1('Таны таскны цаг ажилсан цагнаас бага байна. Зөв бөглөнө үү!!!');
      } else if(parseFloat(this.data.workTime) == sum){
        // API
        for(let i = 0; i  < this.userTaskId.length;i++) {
          await this.rest.addTimeTable(this.userTaskId[i].id, this.userTaskId[i].value, this.data.userId ).pipe(first()).toPromise();
        }
        this.showToast('Таны таскны зарцуулалт амжилттай бүртгэгдлээ.');
        if(this.type == null) {
          this.viewCtrl.dismiss({data: this.userTaskId});
        }
        let nav = this.app.getRootNavs();
        /*if(parseInt(this.data.type) == 2 || parseInt(this.data.type) == 4) {
          nav[0].setRoot(AdminDashboardPage);
        } else {*/
          nav[0].setRoot(DashboardPage);
        // }
      }
    }
  }

  async addZTimeRe(){
    this.userTaskId = [];
    let sum = 0;
    for(let i = 0; i  < this.taskInput.length;i++) {
      if(this.taskInput[i] != null) {
        sum = sum + parseFloat(this.taskInput[i]);
        this.userTaskId.push({id: this.tasks1[i].id, value: this.taskInput[i]});
      }
    }
    // this.getTask();
    if(sum < 0){
      this.showToast1('Таскны цаганд хасах тоо оруулж болохгүй. Шалгаад зөв бөглөнө үү!!!');
    } else if(sum > 0){
      if(parseFloat(this.workTime) < sum) {
        this.showToast1('Таны таскны цаг ажилсан цагнаас их байна. Зөв бөглөнө үү!!!');
      } else if(parseFloat(this.workTime) > sum){
        this.showToast1('Таны таскны цаг ажилсан цагнаас бага байна. Зөв бөглөнө үү!!!');
      } else if(parseFloat(this.workTime) == sum){
        // API
        for(let i = 0; i  < this.userTaskId.length;i++) {
          await this.rest.addTimeTableRe(this.userTaskId[i].id, this.userTaskId[i].value, this.data.userId, this.retime.timetable_id).pipe(first()).toPromise();
        }

        this.showToast('Таны таскны зарцуулалт амжилттай бүртгэгдлээ.');


        // this.getTask();
        this.rest.timeBegin(this.data.userId, new Date(), 'irsen', '', '').subscribe(res => {
          if(res.result) {
            if(res.msg == 'ok'){
              this.showToast('Ирсэн цаг амжилттай бүртгэгдлээ.');
            } else if(res.msg == 'no') {
              this.showToast1('Ирсэн цаг аль хэдийн бүртгэгдсэн байна.');
            }
          } else {
            this.showToast1('Та зөвхөн ажил дээрээсээ цагаа хийх боломжтой.');
          }
        });
        if(this.type == null) {
          this.viewCtrl.dismiss({data: this.userTaskId});
        }
        let nav = this.app.getRootNavs();
        // if(parseInt(this.data.type) == 2 || parseInt(this.data.type) == 4) {
        //   nav[0].setRoot(AdminDashboardPage);
        // } else {
          nav[0].setRoot(DashboardPage);
        // }
      }
    }
  }

  addZTimeRequest() {
    this.userTaskId = [];
    let sum = 0;
    for(let i = 0; i  < this.taskInput.length;i++) {
      if(this.taskInput[i] != null) {
        sum = sum + parseFloat(this.taskInput[i]);
        this.userTaskId.push({id: this.tasks1[i].id, value: this.taskInput[i]});
      }
    }
    // this.getTask();
    if(sum < 0){
      this.showToast1('Таскны цаганд хасах тоо оруулж болохгүй. Хуудсаа шинэчлээд дахин оролдоно уу!!!');
    } else if(sum > 0){
      if(parseFloat(this.workTime) < sum) {
        this.showToast1('Таны таскны цаг ажилсан цагнаас их байна. Зөв бөглөнө үү!!!');
      } else if(parseFloat(this.workTime) > sum){
        this.showToast1('Таны таскны цаг ажилсан цагнаас бага байна. Зөв бөглөнө үү!!!');
      } else if(parseFloat(this.workTime) == sum){
        this.viewCtrl.dismiss({data: this.userTaskId});
      }
    }
  }
  
  onEnterSave(event: KeyboardEvent) {
	event.preventDefault();

  if (this.type == null) {
    if (this.retime) {
      this.addZTimeRe();
    } else {
      this.addZTime();
    }
  } else {
    this.addZTimeRequest();
  }
}

  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/task/task.ts